import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgStarsAndBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 196 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#E6F2FF" d="M137.736 13.621h10.63v26.978h-10.63z" />
    <path fill="#E6F2FF" d="M130.031 40.599h10.63v63.075h-10.63z" />
    <path
      d="M49.166 41.194h-7.531V14h106.73v27.194h-7.531m-91.668 0v62.859h91.668V41.194m-91.668 0h91.668"
      stroke="#C2C5CC"
      strokeDasharray="2 2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.94 29.526-5.877 3.09 1.123-6.544-4.756-4.636 6.572-.955 2.939-5.955 2.939 5.955 6.571.955-4.755 4.636 1.123 6.545-5.878-3.09Zm169.295-6.441-8.653 4.441 1.653-9.407-7-6.662 9.674-1.372 4.326-8.559 4.326 8.559 9.674 1.372-7 6.662 1.652 9.407-8.652-4.441ZM37.193 110.401l-4.018 2.05.768-4.341-3.25-3.075 4.491-.634 2.009-3.95 2.008 3.95 4.492.634-3.25 3.075.767 4.341-4.017-2.05Z"
      fill="#fff"
      stroke="#E6E9EE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83 63.026a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm24 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      fill="#17181A"
    />
    <rect
      x={72}
      y={54.026}
      width={45}
      height={15}
      rx={7.5}
      stroke="#C2C5CC"
      strokeDasharray="2 2"
    />
  </svg>
);
const Memo = memo(SvgStarsAndBox);
export default Memo;
